import { parse, type ParsedUrlQuery } from 'querystring';
import { useSearchParams } from 'next/navigation';

import { useConfig } from '@packages/utilities';
import type { Config } from '@packages/config';

export const ONBOARDING_QUERY_PARAM = 'lassDichInspirieren';

/**
 * Get the activation status for Inspiring Search features (usable on server and client)
 */
export const getInspiringSearchSettings = (query: ParsedUrlQuery, config: Config) => {
  const {
    search: { isInspiringSearchEnabled: isEnabledInConfig },
  } = config;

  const forceAiEnhancement = !!query.alwaysAi || ONBOARDING_QUERY_PARAM in query;

  const isInspiringSearchEnabled = isEnabledInConfig || !!query.enableAi || forceAiEnhancement;

  return {
    forceAiEnhancement,
    isInspiringSearchEnabled,
  };
};

/**
 * Get the activation status for Inspiring Search features (client hook for convenience)
 */
export const useInspiringSearchSettings = () => {
  const config = useConfig();
  const searchParams = useSearchParams();
  // NOTE: null check is for pages/app router compat mode, later for pure app router this can never be null
  const query = parse(searchParams?.toString() ?? '');

  return getInspiringSearchSettings(query, config);
};
